// assets/reading-text.js
(() => {
  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

  class ReadingText {
    constructor(section) {
      this.section = section;
      this.stage = section.querySelector('.reading-text__stage');
      this.sticky = section.querySelector('.reading-text__sticky');
      this.lettersWrap = section.querySelector('[data-reading-letters]');

      if (!this.stage || !this.sticky || !this.lettersWrap) return;

      this.speed = parseFloat(section.dataset.readingSpeed || '1');
      this.initialOpacity = parseFloat(section.dataset.initialOpacity || '0.2');
      this.raf = null;

      this.buildLetters();

      this.letters = Array.from(this.section.querySelectorAll('.rt-letter'));
      if (!this.letters.length) return;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);

      this.updateMetrics();
      this.render();

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
    }

    buildLetters() {
      const text = (this.section.dataset.heading || '').trim();
      if (!text) return;

      this.lettersWrap.innerHTML = '';

      const words = text.split(/\s+/);

      words.forEach((word, wordIndex) => {
        const wordEl = document.createElement('span');
        wordEl.className = 'rt-word';
        wordEl.setAttribute('aria-hidden', 'true');

        [...word].forEach((char) => {
          const letterEl = document.createElement('span');
          letterEl.className = 'rt-letter';
          letterEl.setAttribute('aria-hidden', 'true');
          letterEl.textContent = char;
          wordEl.appendChild(letterEl);
        });

        this.lettersWrap.appendChild(wordEl);

        if (wordIndex < words.length - 1) {
          const spaceEl = document.createElement('span');
          spaceEl.className = 'rt-space';
          spaceEl.setAttribute('aria-hidden', 'true');
          spaceEl.innerHTML = '&nbsp;';
          this.lettersWrap.appendChild(spaceEl);
        }
      });
    }

    updateMetrics() {
      const rect = this.stage.getBoundingClientRect();
      this.stageTop = rect.top + window.scrollY;
      this.stageHeight = this.stage.offsetHeight;
      this.stickyHeight = this.sticky.offsetHeight || window.innerHeight;
      this.scrollDistance = Math.max(this.stageHeight - this.stickyHeight, 1);
    }

    getProgress() {
      const y = window.scrollY - this.stageTop;
      const raw = y / this.scrollDistance;

      const eased = clamp(raw * this.speed, 0, 1);
      return eased;
    }

    render() {
      const progress = this.getProgress();
      const total = this.letters.length;
      const exactVisible = progress * total;

      for (let i = 0; i < total; i++) {
        const delta = exactVisible - i;
        let opacity = this.initialOpacity;
        let translate = 0.18;

        if (delta >= 1) {
          opacity = 1;
          translate = 0;
        } else if (delta > 0) {
          opacity = this.initialOpacity + (1 - this.initialOpacity) * delta;
          translate = 0.18 * (1 - delta);
        }

        this.letters[i].style.opacity = String(opacity);
        this.letters[i].style.transform = `translateY(${translate}em)`;
      }

      this.section.setAttribute('data-complete', progress >= 0.999 ? 'true' : 'false');
    }

    onScroll() {
      if (this.raf) cancelAnimationFrame(this.raf);

      this.raf = requestAnimationFrame(() => {
        this.render();
      });
    }

    onResize() {
      this.updateMetrics();
      this.render();
    }

    destroy() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);

      if (this.raf) cancelAnimationFrame(this.raf);
    }
  }

  const init = (root = document) => {
    root.querySelectorAll('[data-reading-text]').forEach((section) => {
      if (section.__readingText) return;
      section.__readingText = new ReadingText(section);
    });
  };

  document.addEventListener('DOMContentLoaded', () => init());

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-reading-text]') || event.target;
    if (section?.__readingText) {
      section.__readingText.destroy();
      delete section.__readingText;
    }
  });
})();